import React, {useState,useEffect,useContext } from "react"
import ExpandableContent from "../components/ExpandableContent"
import InternalLinkingBlock from "../components/InternalLinkingBlock"
import FAQ from "../components/FAQ"
import LinkBlock from "../components/LinkBlockComponent"
import Layout from "../components/LayoutV2"
import PopularCities from "../components/popularCities"
import LocationWidget from "../components/LocationCarousel"
import Event from "../components/Event"
import * as Fn from "../functions"
import _ from "lodash"
// import Ad from 'react-google-publisher-tag';
import { getCookie } from "@airasia/phoenix-widgets/widgets/FlightSearchWidget/utils"
import PhoenixUtil from "../components/PhoenixUtilities/utilities"
import InfoCardsSection from "../components/InfoCardsSection"


const SecondPage = props => {
  var [width,Setwidth] = useState()
  // console.log("width",width)

  var Data = props.pageContext.data;
  const lang = _.get(props, "pageContext.lang", "en-gb");
  var [GlobalState, setGlobalState] = useState(() => {
    if(typeof(window) !== "undefined"){
      let pathNameSplitted = window.location.pathname.split("/");
      let langCodesArray = pathNameSplitted.filter(x => x.length===2);
      let urlLocale = langCodesArray.length === 2 ? `${langCodesArray[0]}-${langCodesArray[1]}` : "en-gb";

      return {
        currency: getCookie("uhfCurrency") || localStorage.getItem("userSelectedCurrency") || "",
        lang: urlLocale
      };
    }
  })
  useEffect(()=>{
    if(typeof(window) !== "undefined"){
      let pathNameSplitted = window.location.pathname.split("/");
      let langCodesArray = pathNameSplitted.filter(x => x.length===2);
      let urlLocale = langCodesArray.length === 2 ? `${langCodesArray[0]}-${langCodesArray[1]}` : "en-gb";
      setGlobalState({
        currency: getCookie("uhfCurrency") || localStorage.getItem("userSelectedCurrency") || "",
        lang: urlLocale
      });
    }
  }, [])
  useEffect(() =>Fn.DynamicWidth(Setwidth),[GlobalState] );
  useEffect(()=>{Fn.useDfpSlot(width,lang.split("-")[0],null,null)},[width])

  const isChinaDomain = PhoenixUtil.isChinaDomainName();

  // console.log("Data.popular_destinations",Data.popular_destinations)
  return (
    <Fn.GlobalContext.Provider
    value={{ state: GlobalState, updateState: setGlobalState }}>
    <Layout
        /* api={props.pageContext.api} */
        breadCrumbs={Data.breadcrumbs}
        routes={Data.routes}
        hero={Data.hero}
        meta={Data.meta}
        url={Data.URL}
        // lang={GlobalState?.lang || "en-gb"}
        lang={lang}
        template={_.get(Data, 'pageTemplateType', 'home')}
        isMOVE={_.get(Data, 'isMOVE', false)}
        head={Data.head}
        currency={_.get(GlobalState, "currency", "")}
        overrides={_.get(props, 'pageContext.overrides', {})}
      >
      {/* <Ad path="/10025506/AirAsia.com/home_page/prime" dimensions={[970, 90]} /> */} 
      <ExpandableContent {...Data.flight_deals}/>
      <LocationWidget data={Data.popular_cities.cards}/>
      {Data.flights.slice(0, 2).map((x,index) => (
        <LinkBlock key={"home"+index} {...x} isMarkdown />
      ))}
      {/* {!isChinaDomain && <div id="div-gpt-ad-1586342250790-0"></div>} */}
      <PopularCities {...Data.popular_cities} />
      {Data.flights.slice(2).map((x,index) => (
        <LinkBlock key={"homeDataFlights"+index} {...x} isMarkdown />
      ))}
      <ExpandableContent {...Data.things_to_do}/>
      {/* <Event {...Data.popular_events} /> */}
      <FAQ {...Data.faq} />
      {/* {!isChinaDomain && <div id="div-gpt-ad-1586342250790-1" style={{marginBottom:"1rem"}}></div>} */}
      <InfoCardsSection title="Plan for Your Next Trip?" 
        subTitle="Celebrating 22 years of connecting ASEAN and beyond with AirAsia. More exclusive Offers Await – Explore Now!" 
        data={whyBookContent} 
        isMasonStyle={false} />
      {/* <InternalLinkingBlock linkObjects={Data.popular_destinations} /> */}
    </Layout>
    </Fn.GlobalContext.Provider>
  )
}
export default SecondPage


const formInfoCardsData = (textData = {}, cardsData = []) => {
  return cardsData.map(card => ({...card, title: _.get(textData, `${card["key"]}.title`, _.get(card, 'title', '')), content: _.get(textData, `${card["key"]}.description`, _.get(card, 'content', ''))}))
}

const whyBookContent = [
  {title: 'Book flight with Ease', content: 'More planes, more destinations for better connectivity within ASEAN and beyond.', imageSrc: 'https://static.airasia.com/seo/images/others/wba1.png', isSmall: true, isRow: true},
  {title: 'Enjoy many flight deals and more', content: 'Enjoy upto RM 22 OFF for Visa Cardholders upon checkout.', imageSrc: 'https://static.airasia.com/seo/images/others/wba2.png', isSmall: true, isRow: true},
  {title: 'Earn more as you travel with us', content: 'Up to 1.5 million AirAsia points to be earned when you purchase a flight with us! *T&C Apply', imageSrc: 'https://static.airasia.com/seo/images/others/wba3.png', isSmall: true, isRow: true}
];

